import VSlider from './VSlider.vue';

export { VSlider };
export default VSlider;
